<template>
    <form ref="acaocomercial-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>
        <div class="row">
            <div class="form-group col-md-4">
                <label for="acaoComercialExternalHash">Ação Comercial Box (Hash)</label>
                <input
                    disabled
                    type="text"
                    class="form-control"
                    name="acaoComercialExternalHash"
                    placeholder="AcaoComercialExternalHash"
                    v-model="model.acaoComercialExternalHash"
                    required
                />
            </div>
            <div class="form-group col-md-4">
                <label for="descricao">Descrição</label>
                <input
                    disabled
                    type="text"
                    class="form-control"
                    name="descricao"
                    placeholder="Descricao"
                    v-model="model.descricao"
                    required
                />
            </div>
            <div class="form-group col-md-4">
                <label for="statusAcaoComercialId">Status Ação Comercial</label>
                <input
                    disabled
                    type="text"
                    class="form-control"
                    name="statusAcaoComercialId"
                    placeholder="StatusAcaoComercialId"
                    v-model="model.statusAcaoComercialId"
                    required
                />
            </div>
            <div class="container">
                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Nome</th>
                                <th>Email</th>
                                <th>Telefone</th>
                                <th>Data Cadastro</th>
                                <th><i class="fa fa-envelope"></i></th>
                                <th><i class="fa-brands fa-whatsapp"></i></th>
                                <th><i class="fa-solid fa-phone"></i></th>
                                <th><i class="fa-solid fa-sms"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="item in model.collectionAcaoComercialCadastro"
                                v-bind:key="item.id"
                                class="animated fadeIn"
                            >
                                <td>{{ item.acaoComercialCadastroId }}</td>
                                <td>{{ item.nome }}</td>
                                <td>{{ item.email }}</td>
                                <td>{{ item.telefone }}</td>
                                <td>{{ item.dataCadastro }}</td>
                                <td>
                                    <label class="custom-control custom-checkbox lbl-check">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            value="model.aceitaEmail"
                                            disabled="true"
                                            :checked="item.aceitaEmail"
                                        />
                                        <span class="custom-control-indicator"></span>
                                    </label>
                                </td>
                                <td>
                                    <label class="custom-control custom-checkbox lbl-check">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            value="model.aceitaEmail"
                                            disabled="true"
                                            :checked="item.aceitaWhatsApp"
                                        />
                                        <span class="custom-control-indicator"></span>
                                    </label>
                                </td>
                                <td>
                                    <label class="custom-control custom-checkbox lbl-check">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            value="model.aceitaEmail"
                                            disabled="true"
                                            :checked="item.aceitaTelefone"
                                        />
                                        <span class="custom-control-indicator"></span>
                                    </label>
                                </td>
                                <td>
                                    <label class="custom-control custom-checkbox lbl-check">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            value="model.aceitaEmail"
                                            disabled="true"
                                            :checked="item.aceitaSMS"
                                        />
                                        <span class="custom-control-indicator"></span>
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-outline-secondary" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>
    </form>
</template>
<script>

import base from '@/common/base.js'
import { Api } from '@/common/api'

export default {
    name: "acaocomercial-form-edit",
    mixins: [base],
    props: { id: Number },
    data: () => ({

        model: {},

        form: "acaocomercial-form-edit",

        resources: {
            edit: 'acaocomercial/LocalizaAcaoComercialCadastros',
        },

    }),

    methods: {

        executeEdit: function (model) {

            if (this.formValidate() == false) return;

            new Api(this.resources.edit).put(model).then(data => {
                this.defaultSuccessResult("Edição realizada com sucesso");
                this.$emit('on-saved', data)
            }, err => {
                this.defaultErrorResult(err);
            })
        },

        formValidate: function () {
            var $form = this.$refs[this.form];
            $form.classList.add("was-validated");
            return $form.checkValidity();
        },

        onBack: function () {
            this.$emit('on-back')
        }
    },

    mounted() {
        new Api(`${this.resources.edit}/${this.id}`).get().then(data => {
            if (data.data) this.model = data.data;
            else if (!data.dataList) this.model = {};
            else if (data.dataList.length == 1) this.model = data.dataList[0];
            else this.model = {};

            console.log(data.data)
        }, err => {
            this.defaultErrorResult(err);
        })
    }
};
</script>